import { BulkMessageStatisticDto } from '@api'

import type { FollowUp } from '@/modules/message/components/follow-ups/types.ts'
import { toPlural } from '@/utils/helpers.ts'

export const generateFollowUpsTableOptions = (
  statistics: FollowUp['statistics'] | BulkMessageStatisticDto | undefined,
) => {
  if (!statistics) {
    return {
      title: '',
      rows: [],
    }
  }

  return {
    title: 'Follow-Up',
    rows: [
      {
        label: 'Sent To',
        value: `${statistics?.totalSent ?? 0} ${toPlural(statistics?.totalSent ?? 0, 'Fan')}`,
      },
      {
        label: 'Reads',
        value: `${statistics?.totalReads ?? 0} ${toPlural(statistics?.totalReads ?? 0, 'Fan')}`,
      },
      {
        label: 'Responses',
        value: `${statistics?.totalResponses ?? 0} ${toPlural(statistics?.totalResponses ?? 0, 'Fan')}`,
      },
      {
        label: 'PPV Bought',
        value: `${statistics?.totalPPVBought ?? 0}`,
      },
    ],
  }
}
